document.addEventListener('DOMContentLoaded', function () {
  const colorMapping = {
    'Black': 'rgb(0, 0, 0)',
    'White': 'rgb(255, 255, 255)',
    'Blue': 'rgb(41, 48, 78)',
    'Black Plum': 'rgb(92, 58, 77)',
    'Cappuccino': 'rgb(169, 128, 106)',
    'Cafe': 'rgb(199, 169, 148)',
    'Taupe': 'rgb(171, 152, 149)',
    'Wine': 'rgb(73, 42, 52)',
    'Gray Heather': 'rgb(106, 106, 106)',
    'Pink Heather': 'rgb(239, 193, 214)',
    'Silver': 'rgb(154, 155, 159)',
    'Dark Denim': 'rgb(18, 57, 85)',
    'Mocha': 'rgb(94, 71, 60)',
    'Blue Azure': 'rgb(98, 131, 205)',
    'Burgundy': 'rgb(92, 41, 53)',
    'Glacier': 'rgb(134, 161, 169)',
    'Soft Gray': 'rgb(154, 155, 159)',
    'Dark Teal': 'rgb(16, 78, 103)',
    'Blush': 'rgb(224, 198, 173)',
    'Frosted Aqua': 'rgb(178, 212, 221)',
    'Ruby Red': 'rgb(152, 37, 81)',
    'Charcoal Gray': 'rgb(108, 104, 104)',
    'Pink Blush': 'rgb(237, 184, 186)',
    'Soft Lilac': 'rgb(175, 164, 206)',
    'Parfait Pink': 'rgb(234, 197, 210)',
    'Rose Violet': 'rgb(192, 66, 138)',
    'Gray/Yellow': 'rgb(106, 106, 106)',
    'Apricot': 'rgb(203, 134, 143)',
    'Lilac': 'rgb(197, 193, 226)',
    'Berry': 'rgb(171, 52, 117)',
    'Jade': 'rgb(149, 166, 159)',
    'Pink': 'rgb(248, 186, 187)',
    'Light Denim': 'rgb(79, 124, 164)',
    'Soft Lilac': 'rgb(175, 164, 206)',
    'Lavender': 'rgb(174, 144, 167)',
    'Dark Gray': 'rgb(99, 102, 106)',
    'Navy': 'rgb(12, 35, 64)',
    'Stone': 'rgb(214, 210, 196)',
    'Spruce': 'rgb(17, 87, 64)',
      'Floral Print': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/1245_floral_print_swatch50.png?v=1647881159',
      alt: 'Floral Print'
      },
      'Navy Print': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/1245_navy_print_swatch50.png?v=1647881159',
      alt: 'Navy Print'
      },
      'Centennial Leopard': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/1245_centennial_leopard_swatch50.png?v=1647881159',
      alt: 'Centennial Leopard'
      },
      'Black-Gray': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/black-gray.png?v=1713262867',
      alt: 'Black/Gray'
      },
      'Fuchsia Print': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/1067_fuchsia_print_swatch50.png?v=1647881159',
      alt: 'Fuchsia Print'
      },
      'White/Gray': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/white-gray.png?v=1635940184',
      alt: 'White/Gray'
      },
      'Blue Tie-Dye': {
      image: 'https://cdn.shopify.com/s/files/1/0067/9972/0484/files/9266_tie_dye_swatch50.png?v=1647881159',
      alt: 'Blue Tie-Dye'
      }
  };

  function applyColorOrImage() {
    document.querySelectorAll('.screenreader').forEach(screenEl => {
      const swatch = screenEl.closest('.product-item__swatch');
      if (!swatch) return;

      const textContent = screenEl.textContent;
      for (const [word, value] of Object.entries(colorMapping)) {
        if (textContent.includes(word)) {
          if (typeof value === 'string') {
            swatch.style.backgroundColor = value;
          } else if (typeof value === 'object' && value.image) {
            if (!swatch.querySelector('.color-image')) {
              const img = document.createElement('img');
              img.classList.add('color-image');
              img.src = value.image;
              img.alt = value.alt || word;
              swatch.insertBefore(img, screenEl);
            }
          }
          break;
        }
      }
    });
  }
  
  function normalizeColorName(str) {
    return str.toLowerCase().replace(/\s+/g, '-');
  }
  
  function applyConfigOptionColors() {
    if (window.location.href.includes('/products')) {
      document.querySelectorAll('.config__option-link[data-swatch-color]').forEach(link => {
        const swatchColorAttr = link.getAttribute('data-swatch-color'); // e.g. "floral-print"
        let mappingValue = null;
        for (const [key, value] of Object.entries(colorMapping)) {
          if (normalizeColorName(key) === swatchColorAttr) {
            mappingValue = value;
            break;
          }
        }
        if (mappingValue) {
          const configOption = link.querySelector('.config__option');
          if (configOption) {
            if (typeof mappingValue === 'string') {
              configOption.style.backgroundColor = mappingValue;
            } else if (typeof mappingValue === 'object' && mappingValue.image) {
              configOption.style.backgroundImage = `url(${mappingValue.image})`;
              configOption.style.backgroundSize = 'cover';
              configOption.style.backgroundPosition = 'center';
            }
          }
        }
      });
    }
  }

  applyColorOrImage();
  applyConfigOptionColors();
  
  const swatchObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches('.screenreader') || node.querySelector('.screenreader') || node.matches('.config__option-link') || node.querySelector('.config__option-link'))  {
              applyColorOrImage();
              applyConfigOptionColors();
            }
          }
        });
      }
    });
  });

  swatchObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
